import { render, staticRenderFns } from "./ViewCandidate.vue?vue&type=template&id=e2d9b042&scoped=true"
import script from "./ViewCandidate.vue?vue&type=script&lang=js"
export * from "./ViewCandidate.vue?vue&type=script&lang=js"
import style0 from "./ViewCandidate.vue?vue&type=style&index=0&id=e2d9b042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d9b042",
  null
  
)

export default component.exports